export default {
  "b2b.provozni-informace-search.widget.label": "Filtr",
  "b2b.provozni-informace-search.dateFrom.label": "Datum od",
  "b2b.provozni-informace-search.dateTo.label": "Datum do",
  "b2b.provozni-informace-search.dateFrom.placeholder": "Zdejte datum od",
  "b2b.provozni-informace-search.dateTo.placeholder": "Zadejte datum do",
  "b2b.provozni-informace-search.button.search": "Hledej"
};
